import { useEffect, useState, type CSSProperties, type ReactNode } from 'react';
import type { FrameBackground } from '@efira/protocol';

import { computeFrameTransform, frameTransformStyle, type FrameTransform } from './frame';

function readViewport(): FrameTransform {
  return computeFrameTransform(window.innerWidth, window.innerHeight);
}

/**
 * Корень overlay: кадр 1080 x 1920, вписанный в окно browser source
 * (docs/ARCHITECTURE.md, 5.1). Содержимое кадра - игры и виджеты - блоки 4+.
 */
export function OverlayFrame({
  children,
  background,
}: {
  children?: ReactNode;
  /** Фон кадра. Прозрачный - и тогда кадр не красится вовсе. */
  background?: FrameBackground;
}) {
  const [transform, setTransform] = useState<FrameTransform>(readViewport);

  useEffect(() => {
    const onResize = () => {
      setTransform(readViewport());
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  /*
   * ФОН РИСУЕТСЯ ТОЛЬКО ПО ЯВНОМУ УКАЗАНИЮ. Пока стример не выключил
   * прозрачность, кадр остаётся прозрачным: browser source кладётся поверх
   * камеры, и любая подложка по умолчанию закрыла бы стримера собой.
   */
  const paint: CSSProperties =
    background === undefined || background.transparent
      ? {}
      : {
          backgroundColor: background.color,
          ...(background.image === ''
            ? {}
            : {
                backgroundImage: `url("${background.image}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }),
        };

  return (
    <div
      data-overlay-root
      data-overlay-background={
        background === undefined || background.transparent ? 'transparent' : 'painted'
      }
      className="overlay-frame"
      style={{ transform: frameTransformStyle(transform), ...paint }}
    >
      {children}
    </div>
  );
}
